import { useEffect, useState } from "react";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { useIsPlace } from "../../reducers/layoutReducer/selectors";

const useHasRecruiterSubscription = () => {
  const isPlace = useIsPlace();
  const [hasSubscription, setHasSubscription] = useState(isPlace);

  useEffect(() => {
    if (isPlace) return;
    caseTransformingAxios
      .get("/add_ons/recruiter_subscription")
      .then((res) => setHasSubscription(res.data))
      .catch(() => setHasSubscription(false));
  }, []);

  return hasSubscription;
};

export default useHasRecruiterSubscription;
